import { render, staticRenderFns } from "./EditPromotion.vue?vue&type=template&id=0f24259c&scoped=true&"
import script from "./EditPromotion.vue?vue&type=script&lang=js&"
export * from "./EditPromotion.vue?vue&type=script&lang=js&"
import style0 from "./EditPromotion.vue?vue&type=style&index=0&id=0f24259c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f24259c",
  null
  
)

export default component.exports